module.exports = __webpack_public_path__ + "static/media/upgrades_icon.36dcb97f.svg";